// Auth endpoints. Every function resolves to the unwrapped `data` payload.
import { apiClient, readTokens } from "../apiClient";
import { USE_MOCK } from "../connection";

const post = (url, body) => apiClient(url, { method: "POST", body: JSON.stringify(body || {}) }).then((res) => res.data);

// Backend mode: login returns JWTs. The app stores the access token as `token` (sent as Authorization: Bearer)
// and the refresh token as `refreshToken` (used by apiClient to renew the access token).
const toSession = (data) => (USE_MOCK || !data ? data : { ...data, token: data.access, refreshToken: data.refresh });

/** -> { email, verificationRequired, demoCode? (mock / backend dev mode only), joined? } */
export const register = (payload) => post("/api/auth/register", payload);
/**
 * -> { token, userId, name, email, tenantId, tenantName, role, teamRole }
 * The form asks for an email; the Django backend's login field is `username`, so the email is sent as `username`.
 */
export const login = (email, password) =>
  post("/api/auth/login", USE_MOCK ? { email, password } : { username: email, password }).then(toSession);
export const logout = () => post("/api/auth/logout");
export const verifyEmail = (email, code) => post("/api/auth/verify-email", { email, code });
/** -> { sent, demoCode? } */
export const resendCode = (email) => post("/api/auth/resend-code", { email });
/** -> { sent, demoCode? } */
export const forgotPassword = (email) => post("/api/auth/forgot-password", { email });
export const resetPassword = (payload) => post("/api/auth/reset-password", payload);
export const deactivateAccount = (confirmation) => post("/api/auth/deactivate", { confirmation });
/** Current user + workspace; same shape as login. */
// /me returns no tokens; keep the stored ones (read after the call, in case apiClient just renewed them).
export const getMe = () => apiClient("/api/auth/me").then((res) => (USE_MOCK || !res.data ? res.data : { ...res.data, ...readTokens() }));
